export default __webpack_public_path__ + "static/media/section2-bg2-h5.e6988321.png";